// @ts-ignore
import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
export default {
    render (createElement) {
        const h = gh || createElement
        return h('input',{
            ref: 'valueInput',
            props: {
                value: this.value
            }
        })
    },
    model:{
        event: 'changemodel'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-base-components-vue-wrapper/src/kendo-base-input-component/index.js